import { render } from "./CourseSetupWizard.vue?vue&type=template&id=41d28411&scoped=true"
import script from "./CourseSetupWizard.vue?vue&type=script&lang=js"
export * from "./CourseSetupWizard.vue?vue&type=script&lang=js"

import "./CourseSetupWizard.vue?vue&type=style&index=0&id=41d28411&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d28411"]])

export default __exports__